/**
 * <CancelGoodbyePage> — étape 5/5 : c'est fait (page)
 *
 * L'accusé de la résiliation : ce qui a été acté, ce qui a été débité, et à qui le reçu part. La
 * seule sortie est le retour à l'espace parent — un accusé n'est jamais une impasse.
 *
 * Le parcours legacy prévoyait aussi un accusé de prise de rendez-vous
 * (`outcome: "rp_appointment_booked"`) qu'aucun écran n'émet : il n'est pas porté.
 */
import React from "react"

import { type UICancelSummaryRow } from "../../../ports/primary/ui/types"
import { Button } from "../../atoms/Buttons/Button"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { CancelSummaryCard } from "../../molecules/CancelSummaryCard"
import { FlowOutcome } from "../../molecules/FlowOutcome"
import { CancelFlowStep } from "../../templates/CancelFlowStep"

const STEP_TITLE = "Résiliation effective"
const HEADLINE = "Votre résiliation est confirmée"
const NOTE =
    "Vous pouvez revenir quand vous voulez — votre espace, votre historique et vos progrès restent accessibles."
const BACK_LABEL = "Retour à mon espace"

export type CancelGoodbyePageProps = {
    /** Ce qui a été acté, déjà daté — fin d'abonnement ou reprise annulée, et le rappel du conseiller. */
    lead: string
    /** Fin d'accès, frais débités, reçu envoyé à. */
    summaryRows: UICancelSummaryRow[]
    onBackToSpace: () => void
    onClose?: () => void
    testID?: string
}

export function CancelGoodbyePage(props: CancelGoodbyePageProps) {
    const { lead, summaryRows, onBackToSpace, onClose, testID } = props

    return (
        <CancelFlowStep testID={testID} stepTitle={STEP_TITLE} step={5} onClose={onClose}>
            <Stack gap="4">
                <FlowOutcome iconName="check-circle" tone="success" message={HEADLINE} detail={lead} />

                <CancelSummaryCard rows={summaryRows} />

                <Text size="text-md" color="text-muted" center>
                    {NOTE}
                </Text>

                <Button label={BACK_LABEL} fullWidth onPress={onBackToSpace} />
            </Stack>
        </CancelFlowStep>
    )
}
